import { render, staticRenderFns } from "./addInsect.vue?vue&type=template&id=406f2df5&scoped=true&"
import script from "./addInsect.vue?vue&type=script&lang=js&"
export * from "./addInsect.vue?vue&type=script&lang=js&"
import style0 from "./addInsect.vue?vue&type=style&index=0&id=406f2df5&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406f2df5",
  null
  
)

export default component.exports